import React from 'react';
import {MatchRowNew} from 'app/components/match/matchRow/MatchRowNew';

const MatchRow = props => {
  return <MatchRowNew {...props} />;
};

export {MatchRow};
